import { render, staticRenderFns } from "./PrimaryTabItem.vue?vue&type=template&id=74b2c97e&scoped=true"
import script from "./PrimaryTabItem.vue?vue&type=script&lang=js"
export * from "./PrimaryTabItem.vue?vue&type=script&lang=js"
import style0 from "./PrimaryTabItem.vue?vue&type=style&index=0&id=74b2c97e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2c97e",
  null
  
)

export default component.exports